import { useQuery } from '@tanstack/react-query';

import { type Suggestion, getSuggestions } from '@website/services/suggestions.service';

export function useSuggestions(query: string, locale: string) {
  const trimmed = query.trim();
  return useQuery<Suggestion[]>({
    queryKey: ['suggestions', locale, trimmed],
    queryFn: () => getSuggestions(trimmed, locale),
    enabled: trimmed.length >= 1,
    staleTime: 60 * 1000,
    placeholderData: (prev) => prev
  });
}
